angular.module('rjmNg.common.api').constant 'CONNECTIONS',
  TYPES: Object.freeze
    ADOBE_ANALYTICS: "adobe-analytics"
    AURORA: "aurora"
    AZURE: "azure"
    AD_WORDS: "ad-words"
    CLOUDSQL: "cloudsql"
    DESK: "deskdotcom"
    FACEBOOK: "facebook"
    GOOGLE_ADWORDS: "googleAdwords"
    GOOGLE_ANALYTICS: "googleAnalytics"
    GOOGLE_ECOMMERCE: "googleEcommerce"
    GOOGLE_ANALYTICS_REPORTING: "google-analytics-reporting"
    HEROKU: "heroku"
    HUBSPOT: "hubspot"
    INTERCOM: "intercom"
    JIRA: "jira"
    MAILCHIMP: "mailchimp"
    MARKETO: "marketo"
    MANDRILL: "mandrill"
    MARIADB: "mariadb"
    MIXPANEL: "mixpanel"
    MONGO: "mongo"
    MSSQL: "mssql"
    MYSQL: "mysql"
    NETSUITE: "netsuite"
    PARDOT: "pardot"
    POSTGRES: "postgres"
    PUSH_API: "push_api"
    QUICKBOOKS: "quickbooks"
    RECURLY: "recurly"
    REDSHIFT: "redshift"
    SALESFORCE: "salesforce"
    SEGMENT: "segment_webhooks"
    SHOPIFY: "shopify"
    STRIPE: "stripe"
    TRELLO: "trello"
    TWITTER: "twitter"
    USER_PUSH: "userpush"
    ZENDESK: "zendesk"
    ZOPIM: "zopim"
    ZUORA: "zuora"
    SQUARE: "square"

  DB_TYPES: Object.freeze [
    'aurora'
    'azure'
    'cloudsql'
    'heroku'
    'mariadb'
    'mysql'
    'postgres'
    'mongo'
    'mssql'
    'redshift'
  ]

  INTEGRATION_REPLICATION_TYPES: Object.freeze
    DB: "db"
    WEB: "web"
    WEBHOOK: "webhook"
    IAPI: "iapi"

  STATUS: Object.freeze
    ACTIVE: '1'
    DELETED: '2'
    USER_PAUSED: '3'
    SYSTEM_PAUSED: '4'
    NOT_CONFIGURED: '5'

  DIRECTIONS: Object.freeze
    INBOUND: 'inbound'
    OUTBOUND: 'outbound'

  REPLICATION_DEFAULT_INTERVAL_MINUTES: 30
